function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "DESKTOP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.5.---Kalkulator-zu\u017Cycia-wody",
  transform: "translate(-1166.000000, -1096.000000)"
}, React.createElement("rect", {
  fill: "none",
  x: 0,
  y: 0,
  width: 1920,
  height: 1747
}), React.createElement("g", {
  id: "kalkulatort",
  transform: "translate(0.000000, 357.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "none",
  x: 0,
  y: 0,
  width: 1920,
  height: 1969
}), React.createElement("g", {
  id: "sekcja-1",
  transform: "translate(615.000000, 39.000000)"
}, React.createElement("g", {
  id: "uprawa-copy",
  transform: "translate(1.000000, 592.000000)"
}, React.createElement("g", {
  id: "produkcja",
  transform: "translate(480.000000, 56.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "ico/ceny/wieprzowina",
  transform: "translate(70.000000, 52.303371)",
  fill: "#9B9B9B",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M35.0877474,20.0213291 C35.4499529,19.5762236 36.1744681,19.5762236 36.5366735,20.0213291 L36.5366735,20.0213291 L44.2339825,29.6355652 C48.6712338,33.9975778 48.6712338,41.56437 44.2338781,46.5494687 C41.8793863,48.7749958 38.891061,49.9322288 35.8121583,49.9322288 C32.7332556,49.9322288 29.7449303,48.7749958 27.3904385,46.5494687 C22.9531872,41.9204338 22.9531872,34.3536416 27.3904385,29.6355652 L27.3904385,29.6355652 Z M35.8121583,21.9797314 L28.7487871,30.7037566 C24.9453692,34.798747 24.8548961,41.2972452 28.7487871,45.303194 C32.6426782,49.1310596 38.9816385,49.1310596 42.9661069,45.303194 C46.7695248,41.030223 46.7695248,34.5317248 42.9661069,30.7927982 L42.9661069,30.7927982 L42.8755295,30.7037566 L35.8121583,21.9797314 Z M30.1072401,31.9501339 C30.4694456,31.5940701 31.0128059,31.5940701 31.3750113,31.9501339 C31.7372168,32.3061977 31.7372168,32.8403447 31.3750113,33.1964086 L31.3750113,33.1964086 L31.2844339,33.2854502 C28.7488915,35.9560827 28.7488915,40.2290537 31.1938564,42.8996863 C32.3711545,44.0569193 34.0011311,44.680108 35.7216852,44.680108 C36.2649412,44.680108 36.627251,45.0362744 36.627251,45.5704214 C36.627251,46.1045684 36.355623,46.3715906 35.8122627,46.3715906 C33.6389257,46.3715906 31.5561662,45.5704214 30.0166627,44.0570219 C26.8471825,40.7632007 26.93776,35.3328941 30.0166627,32.0391755 L30.0166627,32.0391755 Z",
  id: "Combined-Shape"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "70px",
    height: "71px",
    viewBox: "0 0 70 71",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wilgotnosc_sucha.dd05143d.svg";
export { SvgComponent as ReactComponent };